import { render, staticRenderFns } from "./UserBoard.vue?vue&type=template&id=cea243aa&scoped=true"
import script from "./UserBoard.vue?vue&type=script&lang=js"
export * from "./UserBoard.vue?vue&type=script&lang=js"
import style0 from "./UserBoard.vue?vue&type=style&index=0&id=cea243aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea243aa",
  null
  
)

export default component.exports